import styled from "styled-components";


const StyledFoot = styled.div` 
    background-color: rgba(6, 214, 160, 1);
    padding:  1rem;
    color: white;
    text-align: center;
    margin-top: 250px;

    h2 {
        margin-bottom: 1rem;
        font-size: large;
        font-family: 'Courier New', Courier, monospace;
    }

`;

export default StyledFoot;